export default {
  GET_ANCILLARY_SERVICE_DATATABLE: 'GET_ANCILLARY_SERVICE_DATATABLE'
}
